import "bootstrap/dist/css/bootstrap.min.css";
import Login from "./pages/Login";
import PageNotFound from "./pages/PageNotFound";
import { Routes, Route } from "react-router-dom";
import Logout from "./pages/Logout";
import AccountInfo from "./pages/AccountInfo";
import RequireAuth from "./components/auth/RequireAuth";
import { UserContextProvider } from "./components/users/UserContext";
import Users from "./pages/Users";
import { createStore } from "redux";
import { Provider } from "react-redux";
import Main from "./pages/Main";

function App() {
  const defaultState = {
    scenarioId: null,
    templateId: null,
    isNeedRefreshSimulation: false,
    isTemplateCurrentScenario: null,
    isChangedCurrentScenario: false,
    updateFolderTreeWithEachIteration: 0,
    simulatedScenarioName: null,
    tree: null,
    isShowFolderContextMenu: null,
    isShowButtonsGroup: "",
    destinationFolderId: null,
    isNeedCreateFirstUserFolder: false,
    isNeedSendToServerNewProperties: false,
    isNeedGetScenarioProperties: false,
    currentDistribution: {
      type: undefined,
      name: undefined,
      value: undefined,
      mean: undefined,
      sigma: undefined,
      min: undefined,
      max: undefined,
      likely: undefined,
    },
    isUpdatedDistribution: true,
    isInActiveSaveDistributionMode: true,
  };

  const reducer = (state = defaultState, action) => {
    switch (action.type) {
      case "SET IS INACTIVE DISTRIBUTION MODE":
        return { ...state, isInActiveSaveDistributionMode: action.payload };
      case "SET IS UPDATED DISTRIBUTION":
        return { ...state, isUpdatedDistribution: action.payload };
      case "SET CURRENT DISTRIBUTION":
        return { ...state, currentDistribution: action.payload };
      case "GET SCENARIO PROPERTIES":
        return { ...state, isNeedGetScenarioProperties: action.payload };
      case "SEND TO SERVER NEW PROPERTIES":
        return { ...state, isNeedSendToServerNewProperties: action.payload };
      case "CREATE_FIRST_USER_FOLDER":
        return { ...state, isNeedCreateFirstUserFolder: action.payload };
      case "SET_FOLDER_ID_FOR_COPY":
        return { ...state, destinationFolderId: action.payload };
      case "SET_IS_SHOW_BUTTONS_GROUP":
        return { ...state, isShowButtonsGroup: action.payload };
      case "SET_IS_SHOW_FOLDER_CONTEXT_MENU":
        return { ...state, isShowFolderContextMenu: action.payload };
      case "SET_TREE":
        return { ...state, tree: action.payload };
      case "UPDATE_FOLDER_TREE":
        return {
          ...state,
          updateFolderTreeWithEachIteration:
            state.updateFolderTreeWithEachIteration + action.payload,
        };
      case "NEW_SCENARIO_SIMULATED_ID":
        return { ...state, scenarioId: action.payload };
      case "NEW_TEMPLATE_SIMULATED_ID":
        return { ...state, templateId: action.payload };
      case "RENAME_SCENARIO":
        return { ...state, simulatedScenarioName: action.payload };
      case "IS_TEMPLATE_CURRENT_SCENARIO":
        return { ...state, isTemplateCurrentScenario: action.payload };
      case "IS_CHANGED_CURRENT_SCENARIO":
        return { ...state, isChangedCurrentScenario: action.payload };
      case "IS_NEED_REFRESH_SIMULATION":
        return { ...state, isNeedRefreshSimulation: action.payload };
      default:
        return state;
    }
  };
  const store = createStore(reducer);

  return (
    <div className="App">
      <Provider store={store}>
        <UserContextProvider>
          <Routes>
            <Route path="login" element={<Login />} />

            <Route element={<RequireAuth />}>
              <Route path="/account-info" element={<AccountInfo />} />
            </Route>

            <Route element={<RequireAuth />}>
              <Route path="/users" element={<Users />} />
            </Route>

            <Route element={<RequireAuth />}>
              <Route path="/logout" element={<Logout />} />
            </Route>

            <Route element={<RequireAuth />}>
              <Route path="/" element={<Main />} />
            </Route>

            <Route element={<RequireAuth />}>
              <Route path="/*" element={<PageNotFound />} />
            </Route>
          </Routes>
        </UserContextProvider>
      </Provider>
    </div>
  );
}

export default App;
